<!-- 培训咨询 -->
<template>
  <div class="layer">
    <van-nav-bar title="在线咨询" placeholder fixed z-index="10" />
    <div class="background-img">
      <img src="@/assets/img/enimg/zixun.png" />
    </div>
    <div class="Online" v-for="(item, index) in lawyerList" :key="index">
      <img :src="item.avatar" class="layer-img" />
      <div class="layer-name">
        <span>{{item.nickname}}律师</span>
        <span>在线咨询</span>
      </div>
      <div class="layer-btn" @click="navMore(1,item.lawyer_id,item.nickname)">
        <button>点击咨询</button>
      </div>
    </div>
    <!-- 培训活动 -->
    <!-- <div class="activity">
      <div class="active-title" @click="navMore(0)">
        <div class="title-left">培训活动</div>
        <div class="title-right">更多</div>
      </div>
      <List :list="list" />
    </div> -->
  </div>
</template>

<script>
import { getActivtyList, lawyerList } from "@/api/apiData";
import List from "./item";
export default {
  components: { List },
  inject: ["Token"],
  data() {
    return {
      list: [], //活动列表
      lawyerList: []
    };
  },
  computed: {},
  methods: {
    navMore(val, id, name) {
      if (val == 0) {
        // 更多
        this.$router.push({
          name: "Activity"
        });
      } else {
        this.$router.push({
          name: "Online",
          query: {
            title: name,
            id: id
          }
        });
      }
    },
    // 获取律师列表
    getLawyerList() {
      var that = this;
      lawyerList().then(res => {
        // //(res);
        if (res.code == 1) {
          that.lawyerList = res.data;
        }
      });
    },
    // 获取活动裂表
    getList() {
      var that = this;
      getActivtyList().then(res => {
        //(res);
        if (res.code == 1) {
          var list = res.data.list;
          if (list.length >= 3) {
            var info = [list[0], list[1], list[2]];
            that.list = info;
          } else {
            that.list = list;
          }
        } else {
          that.$toast(res.msg);
        }
      });
    }
  },
  created() {},
  mounted() {
    // this.Token();
    // this.getList();
    this.getLawyerList();
  }
};
</script>
<style lang='less' scoped>
/deep/.van-nav-bar__placeholder {
  height: 0.8rem !important;
}
.layer {
  background: #f7f7f7;
  padding: 0.2rem 0.32rem;
}
.background-img {
  img {
    width: 100%;
    height: 2.6rem;
    border-radius: 0.16rem;
  }
}
.Online {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 0.08rem;
  padding: 0.2rem 0.32rem;
  margin-bottom: 0.2rem;
  .layer-img {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
  .layer-name {
    margin-left: 0.16rem;
    flex: 2;
    font-size: 0.3rem;
    font-weight: bold;
    line-height: 1.5;
    color: rgba(51, 51, 51, 1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    span:last-child {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.26rem;
      color: rgba(102, 102, 102, 1);
      margin-top: 0.1rem;
    }
  }
  .layer-btn {
    font-size: 0.24rem;
    font-weight: 400;
    line-height: 0.33rem;
    color: rgba(255, 255, 255, 1);
    button {
      padding: 0.15rem 0.2rem;
      border-radius: 0.16rem;
      background: #ff4343;
    }
  }
}
.activity {
  margin-top: 0.2rem;
  .active-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.19rem 0;
    .title-left {
      display: flex;
      align-items: center;
      font-size: 0.3rem;
      font-weight: bold;
      line-height: 0.42rem;
      color: rgba(50, 50, 50, 1);
    }
    .title-left::before {
      content: "";
      display: block;
      height: 0.3rem;
      width: 0.06rem;
      border-radius: 0.06rem;
      background: #ff4343;
      margin-right: 0.1rem;
    }
    .title-right {
      display: flex;
      align-items: center;
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(153, 153, 153, 1);
    }
    .title-right::after {
      display: block;
      content: "";
      width: 0.15rem;
      height: 0.15rem;
      border-top: 0.01rem solid rgba(178, 178, 178, 0.8);
      border-right: 0.01rem solid rgba(178, 178, 178, 1);
      transform: rotate(45deg);
      position: relative;
      top: -0.03rem;
    }
  }
}
</style>